import { render, staticRenderFns } from "./OrderHouse.vue?vue&type=template&id=89a518f0&scoped=true&"
import script from "./OrderHouse.vue?vue&type=script&lang=js&"
export * from "./OrderHouse.vue?vue&type=script&lang=js&"
import style0 from "./OrderHouse.vue?vue&type=style&index=0&id=89a518f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a518f0",
  null
  
)

export default component.exports